import { DevicePickerDropdownProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/DevicePickerDropdown';
import { DevicePickerImageProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/DevicePickerImage';
import DevicePanel, { DevicePanelProps } from '@ubnt/link-core-ui/components/BottomPanel/layout/DevicePanel';
import React, { memo } from 'react';

import { WifiStandardIconProps } from 'modules/bottomPanel/components/elements/WifiStandardIcon';
import { OutdoorSwitchProps } from 'modules/bottomPanel/components/elements/OutdoorSwitch';
import { MountSwitchProps } from 'modules/bottomPanel/components/elements/MountSwitch';

import classes from './DevicePanel.module.scss';

export interface ApDevicePanelProps extends DevicePanelProps {
  ChangeAntennaButton: React.ElementType;
  DevicePickerDropdown: React.ElementType<Partial<DevicePickerDropdownProps>>;
  DevicePickerImage: React.ElementType<Partial<DevicePickerImageProps>>;
  WifiStandardIcon: React.ElementType<Partial<WifiStandardIconProps>>;
  OutdoorSwitch: React.ElementType<Partial<OutdoorSwitchProps>>;
  MountSwitch: React.ElementType<Partial<MountSwitchProps>>;
}

const ApDevicePanel = (props: ApDevicePanelProps) => {
  const {
    ChangeAntennaButton,
    DevicePickerDropdown,
    DevicePickerImage,
    WifiStandardIcon,
    OutdoorSwitch,
    MountSwitch,
    ...rest
  } = props;

  return (
    <DevicePanel
      className={classes.WifiDevicePanel}
      image={<DevicePickerImage popoverAlign="rightCenter" />}
      imageFooter={
        <div className={classes.imageFooterContent}>
          <DevicePickerDropdown
            popoverAlign="rightCenter"
            classNamePopoverWrap={classes.popoverWrap}
            classNameDevicePickerList={classes.devicePickerList}
            classNameDevicePicker={classes.devicePicker}
            classNamePopoverCard={classes.popoverCard}
          />
        </div>
      }
      inputsClassName={classes.devicePanelInputs}
      imagePanelClassName={classes.deviceImagePanel}
      imageContainerClassName={classes.imageContainer}
      mainContentClassName={classes.mainContent}
      {...rest}
    >
      <WifiStandardIcon className={classes.iconPlacement} />
      <div className={classes.buttonGroup}>
        <OutdoorSwitch />
        <MountSwitch />
        <ChangeAntennaButton />
      </div>
    </DevicePanel>
  );
};

const MemoizedApDevicePanel = memo(ApDevicePanel);

export default MemoizedApDevicePanel;
